import React, { Component } from 'react';
import { Button, ButtonToolbar, FormGroup, FormControl, ControlLabel, Modal, Form, HelpBlock } from 'react-bootstrap'
import Select from "react-select";

import { MapPointStops } from "../mapPointStops/MapPointStops";

export class MapPointActiveForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            render: {
                showStopsForm: false
            }
        };
    }

    // ---------------------
    
    onSelectStopValue(e) {
        const { stops } = this.props;

        const mappedStop = stops.filter(stop => stop.id === e.value);
        if(undefined === mappedStop) {
            return;
        }

        this.props.onSelectValue(mappedStop, "stops");
    }

    onRemoveSelectedStopValue(e) {
        const { stops, form } = this.props;

        const mappedStop = stops.filter(stop => stop.id === e);
        if(undefined === mappedStop) {
            return;
        }

        this.props.onRemoveSelectValue(e, "stops");

    }

    onShowStopsForm() {
        const { render } = this.state;

        render.showStopsForm = true;

        this.setState({
            render: render
        });
    }

    onHideStopsForm() {
        const { render } = this.state;

        render.showStopsForm = false;

        this.setState({
            render: render
        });
    }

    // ---------------------

    render() {
        const { form } = this.props;

        if (undefined === form) {
            return null;
        }

        const { show, interfaces, stops } = this.props;
        const { render } = this.state;

        return (
            <Modal show={show}>
                <Modal.Header>
                    <Modal.Title>
                        {form.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup controlId="formName" validationState={form.nameInputError}>
                            <ControlLabel>Nome</ControlLabel>
                            <FormControl
                                type="text"
                                value={form.obj.name}
                                placeholder="Introduza o nome"
                                onChange={(e) => this.props.onChangeValue(e, "name")}
                            />
                            {form.nameInputError !== null
                                ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="formLatitude" validationState={form.latitudeInputError}>
                            <ControlLabel>Latitude</ControlLabel>
                            <FormControl
                                type="number"
                                value={form.obj.latitude}
                                placeholder="Introduza a Latitude"
                                onChange={(e) => this.props.onChangeValue(e, "latitude")}
                            />
                            {form.latitudeInputError !== null
                                ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="formLongitude" validationState={form.longitudeInputError}>
                            <ControlLabel>Longitude</ControlLabel>
                            <FormControl
                                type="number"
                                value={form.obj.longitude}
                                placeholder="Introduza a Longitude"
                                onChange={(e) => this.props.onChangeValue(e, "longitude")}
                            />
                            {form.longitudeInputError !== null
                                ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="formAddInfo">
                            <ControlLabel>Informação Adicional</ControlLabel>
                            <FormControl
                                type="text"
                                value={form.obj.addInfo}
                                placeholder="Introduza a informação adicional"
                                onChange={(e) => this.props.onChangeValue(e, "addInfo")}
                            />
                        </FormGroup>

                        <FormGroup controlId="formInterfaces">
                            <ControlLabel>Interfaces</ControlLabel>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Interfaces"
                                noOptionsMessage={() => "Sem Interfaces Configuradas"}
                                onChange={(e) => this.props.onSelectValue(e, "interfaces")}
                                options={interfaces}
                                isMulti={true}
                                isOptionSelected={function (a) {
                                    if (undefined !== form.obj.interfaces) {
                                        return form.obj.interfaces.includes(a.id);
                                    }
                                }}
                                getOptionValue={value => value.id}
                                getOptionLabel={label => label.namePt}
                                value={form.obj.interfaces}
                            />
                        </FormGroup>
                    </Form>

                    <ButtonToolbar>
                        <Button onClick={() => this.onShowStopsForm()}> GERIR PARAGENS ASSOCIADAS </Button>
                        <Button onClick={() => this.props.onCalculateCoordinates()}> CALCULAR COORDENADAS </Button>
                        <Button className="btns-two-lines-small-screens-inside-modal" onClick={() => this.props.onSave()}> GUARDAR ALTERAÇÕES </Button>
                        <Button className="margin-top-10 btns-two-lines-small-screens-inside-modal" onClick={() => this.props.onHide()}> CANCELAR </Button>
                    </ButtonToolbar>

                    <MapPointStops
                        show={render.showStopsForm}
                        onChangeStopValue={(a) => this.onSelectStopValue(a, "stops")}
                        onRemoveSelectedStopValue={(a) => this.onRemoveSelectedStopValue(a, "stops")}
                        mapPoint={form.obj}
                        stops={stops}
                        onHide={() => this.onHideStopsForm()} />
                </Modal.Body>
            </Modal >
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/mapPoints/providerMapPoints/MapPointActiveForm.js